import { createContext } from 'react';
import type { MercureEventSource } from '../lib/mercure-event-source';

export type MercureContext = MercureEventSource;

export const MercureContext = createContext<MercureContext | null>(null);
